import {
  CONTACT_US_FROM_HEADER_PAGE_LINK,
  LOGIN_PAGE_LINK,
  PRICING_PAGE_LINK,
  NEW_SOFT_SIGNUP_LINK
} from "constants/links";
import Button from "segments/desktop/core-components/button/button";
import RegularButton from "segments/desktop/core-components/button/regular-button/regular-button";
import classnames from "classnames";
import {
  shouldGetContactSalesTypeformTest,
  shouldHaveHeaderWithoutProjectsTest
} from "services/ab-tests/acquisition-ab-test-service";
import { SIGNUP_BUTTON_TYPE } from "segments/desktop/core-components/button/button-consts";
import { withAbTests } from "contexts/ab-tests-context";
import { withRouter } from "next/router";
import HeaderConstants from "segments/desktop/header/layouts/base-header/constants.js";
import { createPopup } from "@typeform/embed";
import "@typeform/embed/build/css/popup.css";
import { trackEvent } from "/services/bigbrain-service";
import {
  TYPEFORM_CONTACT_SALES_QUESTION_CHANGED,
  TYPEFORM_CONTACT_SALES_FORM_LOADED,
  TYPEFORM_CONTACT_SALES_FORM_SUBMITTED,
  TYPEFORM_CONTACT_SALES_FORM_CLOSED
} from "constants/bigbrain-event-types";
import { getContactSalesRegionByCountry } from "services/countries/countries-service";
import { getTypeformContactSalesFormId } from "constants/typeform-contact-sales";
import {
  FEATURES_MENU_ID,
  PRODUCTS_MENU_ID,
  productsWithoutProjectsSectionMenuItems,
  RESOURCES_MENU_ID,
  SectionsHeadersMenuItemsMapping,
  SectionsLinkWithMenuMenuComponentMapping,
  USE_CASES_MENU_ID
} from "segments/desktop/header/layouts/base-header/base-header-service.js";
import { WORK_OS_IRIS_COLOR_NAME } from "styles/color-consts";
import { isExistingUserInWelcomeBackTest } from "services/monday-platform/existing-accounts-service";
import LinkItemComponent from "../link-item/link-item-component";
import { withGenericConfig } from "/contexts/generic-config-context";
import LinkItemWithMenuComponent from "../link-item-with-menu/link-item-with-menu-component";

import HeaderMenus from "../header-menu";

const UniverseHeader = (props) => {
  const {
    showMenu,
    showButton,
    buttonConfig,
    shouldShowMainPricingLink,
    isSecondaryMenuNeeded,
    renderUnifiedLinks,
    openSignupPopup,
    hideLogin,
    abTests,
    testTypeformContactSales,
    cloudfrontViewerCountry,
    openedMenuId,
    openLinkMenu,
    closeLinkMenu,
    headerWithoutProjects,
    isExistingAccountHeader,
    translate
  } = props;

  const openProductsMenu = () => openLinkMenu(PRODUCTS_MENU_ID);
  const openWorkflowsMenu = () => openLinkMenu(USE_CASES_MENU_ID);
  const openFeaturesMenu = () => openLinkMenu(FEATURES_MENU_ID);
  const openResourcesMenu = () => openLinkMenu(RESOURCES_MENU_ID);

  const isMenuOpen = (menuId) => {
    return openedMenuId === menuId;
  };

  const renderBaseHeaderLeftLinks = () => {
    return (
      <>
        <div
          className={classnames("link-item-with-menu-component-wrapper", { "is-open": isMenuOpen(PRODUCTS_MENU_ID) })}
          role="listitem"
        >
          <LinkItemWithMenuComponent
            title="header.products"
            openMenu={openProductsMenu}
            closeMenu={closeLinkMenu}
            isOpen={isMenuOpen(PRODUCTS_MENU_ID)}
          />
        </div>
        {renderSubmenuWithTransitionIfNeeded(PRODUCTS_MENU_ID)}

        <div
          className={classnames("link-item-with-menu-component-wrapper", { "is-open": isMenuOpen(USE_CASES_MENU_ID) })}
          role="listitem"
        >
          <LinkItemWithMenuComponent
            title="header.useCases"
            openMenu={openWorkflowsMenu}
            closeMenu={closeLinkMenu}
            isOpen={isMenuOpen(USE_CASES_MENU_ID)}
          />
        </div>
        {renderSubmenuWithTransitionIfNeeded(USE_CASES_MENU_ID)}

        <div
          className={classnames("link-item-with-menu-component-wrapper", { "is-open": isMenuOpen(FEATURES_MENU_ID) })}
          role="listitem"
        >
          <LinkItemWithMenuComponent
            title="header.features"
            openMenu={openFeaturesMenu}
            closeMenu={closeLinkMenu}
            isOpen={isMenuOpen(FEATURES_MENU_ID)}
          />
        </div>
        {renderSubmenuWithTransitionIfNeeded(FEATURES_MENU_ID)}

        <div
          className={classnames("link-item-with-menu-component-wrapper", { "is-open": isMenuOpen(RESOURCES_MENU_ID) })}
          role="listitem"
        >
          <LinkItemWithMenuComponent
            title="header.resources"
            openMenu={openResourcesMenu}
            closeMenu={closeLinkMenu}
            isOpen={isMenuOpen(RESOURCES_MENU_ID)}
          />
        </div>
        {renderSubmenuWithTransitionIfNeeded(RESOURCES_MENU_ID)}
      </>
    );
  };

  const onContactSalesClicked = () => {
    const region = getContactSalesRegionByCountry(cloudfrontViewerCountry);
    const formId = getTypeformContactSalesFormId(cloudfrontViewerCountry, region);

    // fire AB test
    if (testTypeformContactSales || shouldGetContactSalesTypeformTest(abTests, true)) {
      const { toggle } = createPopup(formId, {
        onQuestionChanged: (data) => {
          trackEvent(TYPEFORM_CONTACT_SALES_QUESTION_CHANGED, {
            kind: data?.ref,
            info1: formId
          });
        },
        onSubmit: (data) => {
          trackEvent(TYPEFORM_CONTACT_SALES_FORM_SUBMITTED, {
            kind: data?.responseId,
            info1: formId
          });
        },
        onReady: () => {
          trackEvent(TYPEFORM_CONTACT_SALES_FORM_LOADED, { info1: formId });
        },
        onClose: () => {
          trackEvent(TYPEFORM_CONTACT_SALES_FORM_CLOSED, { info1: formId });
        },
        hidden: {
          region,
          country: cloudfrontViewerCountry,
          keepSession: "true"
        }
      });
      toggle();
    }
  };

  const renderContactSalesButton = () => {
    let buttonURLProp = {};
    if (!testTypeformContactSales && !shouldGetContactSalesTypeformTest(abTests)) {
      buttonURLProp = { url: CONTACT_US_FROM_HEADER_PAGE_LINK };
    }

    return (
      <div className="link-item-component-wrapper">
        <LinkItemComponent title="header.contactSales" clickEvent={onContactSalesClicked} {...buttonURLProp} />
      </div>
    );
  };

  const renderSubmenuWithTransitionIfNeeded = (menuId) => {
    // always render transition - menu rendered only if open
    const isMenuOpen = openedMenuId === menuId;

    return <div>{isMenuOpen && renderMainHeaderPopup(menuId)}</div>;
  };

  const isHeaderWithoutProjects = (sendBigBrainEvent = false) =>
    headerWithoutProjects || shouldHaveHeaderWithoutProjectsTest(abTests, sendBigBrainEvent);

  const getProductsMenuVariant = () => {
    if (headerWithoutProjects || isHeaderWithoutProjects(true)) {
      return productsWithoutProjectsSectionMenuItems;
    }
    return SectionsHeadersMenuItemsMapping[PRODUCTS_MENU_ID];
  };

  const renderMainHeaderPopup = (menuId) => {
    const headerMenuItems =
      menuId !== PRODUCTS_MENU_ID ? SectionsHeadersMenuItemsMapping[menuId] : getProductsMenuVariant();
    const MenuComponent = HeaderMenus[SectionsLinkWithMenuMenuComponentMapping[menuId]];

    return (
      <div className={HeaderConstants.HEADER_MENU_COMPONENT_WRAPPER_CLASS_NAME} key={menuId}>
        <nav aria-label="main submenu" className="menu-component-wrapper">
          {MenuComponent && <MenuComponent menuItems={headerMenuItems} menuId={menuId} />}
        </nav>
      </div>
    );
  };

  const buildHeaderStructure = () => {
    // init header according to its props
    const headerStructure = {
      leftLinks: { isVisible: showMenu },
      pricing: { isVisible: showMenu && shouldShowMainPricingLink() },
      contactSales: { isVisible: showButton && buttonConfig?.buttonType === SIGNUP_BUTTON_TYPE },
      login: { isVisible: showMenu && !hideLogin },
      createNewAccountButton: { isVisible: false },
      button: {
        isVisible: showButton
      }
    };

    if (
      buttonConfig?.buttonType === SIGNUP_BUTTON_TYPE &&
      (isExistingAccountHeader || isExistingUserInWelcomeBackTest())
    ) {
      headerStructure.login.isVisible = false;
      headerStructure.createNewAccountButton.isVisible = true;
      headerStructure.button.extraProps = { forceGoToMyAccount: true };
    }

    return headerStructure;
  };

  const { leftLinks, pricing, contactSales, login, button, createNewAccountButton } = buildHeaderStructure();

  return (
    <nav
      aria-label="Main"
      className={classnames("base-header-desktop-content", "universe-header-desktop-content", "products-with-tags")}
    >
      {leftLinks.isVisible && (
        <div className="left-side-header-links">
          <div className="absolute-main-links" role="list">
            {renderBaseHeaderLeftLinks()}
          </div>
          {isSecondaryMenuNeeded && <div className="absolute-unified-links">{renderUnifiedLinks()}</div>}
        </div>
      )}

      <div className="right-side-header-links">
        {pricing.isVisible && (
          <div className="link-item-component-wrapper">
            <LinkItemComponent title="header.pricing" url={PRICING_PAGE_LINK} />
          </div>
        )}

        {contactSales.isVisible && renderContactSalesButton()}

        {login.isVisible && (
          <div className="link-item-component-wrapper">
            <LinkItemComponent title="header.logIn" url={LOGIN_PAGE_LINK} />
          </div>
        )}
      </div>

      {createNewAccountButton.isVisible && (
        <div className="header-create-account-button-wrapper">
          <RegularButton
            buttonText={translate("existingAccount.createAccountCta")}
            color={WORK_OS_IRIS_COLOR_NAME}
            outline={true}
            url={NEW_SOFT_SIGNUP_LINK}
          />
        </div>
      )}

      {button.isVisible && (
        <div className="header-button-wrapper">
          <Button
            {...buttonConfig}
            parentSegment={HeaderConstants.DESKTOP_HEADER_SEGMENT_NAME}
            onButtonClick={openSignupPopup}
            {...button.extraProps}
          />
        </div>
      )}
    </nav>
  );
};

export default withGenericConfig(withRouter(withAbTests(UniverseHeader)));
